import styled from 'styled-components'

const StyledStoriesView = styled.div`
  
`

export default StyledStoriesView
